export const worksData = [
  "Book Recommendation Website",
  "Small Social Media Platform",
  "NextJS Movie Website",
  "Small ERP System",
  "Jewelry Shop Website",
  "Coffee Review Website",
  "React Weather Webiste",
  "Old Portfolio",
  "JS Weather Website",
];

export const miniWorksData = [
  "ChocolateCard",
  "Chocolate",
  "WebPage",
  "DashBoard",
];
